import CompleteContract from "@/views/common/aone/CompleteContract.vue";
import InicisSuccessComponent from "@/views/common/aone/InicisSuccessComponent.vue";
import ConflictCompleteContract from "@/views/common/aone/ConflictCompleteContract.vue";

export default [
    {
        path: '/completeContract',
        component: CompleteContract,
        name: 'CompleteContract',
    },
    {
        path: '/inicisSuccessComponent',
        component: InicisSuccessComponent,
        name: 'InicisSuccessComponent',
    },
    {
        path: '/conflictCompleteContract',
        component: ConflictCompleteContract,
        name: 'ConflictCompleteContract',
    },
]
